import { render, staticRenderFns } from "./CreateContentModal.vue?vue&type=template&id=dbb59454"
import script from "./CreateContentModal.vue?vue&type=script&lang=js"
export * from "./CreateContentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports